import React from "react";
import styled from "styled-components";
import TableItem from "../atoms/TableItem";
import TableHeader from "../atoms/TableHeader";
import TableRow from "../atoms/TableRow";
import { color } from "../templates/ui";
import { moneyFormat } from "../../services/currencyService";
import { useTranslation } from "react-i18next";
import { dateFormat } from "../../services/dateService";
const StyledInvoiceTable = styled.div ``;
const StyledLabel = styled.label `
  display: block;
  font-family: ${props => props.theme.fontBase};
  font-size: 14px;
  font-weight: 600;
  margin-right: 10px;
  color: ${color.gray.base};

  @media only screen and (min-width: 540px) {
    display: none;
  }
`;
const StyledTableHeader = styled(TableHeader) `
  display: none;

  @media only screen and (min-width: 540px) {
    display: flex;
  }
`;
const StyledTableRow = styled(TableRow) `
  display: block;

  @media only screen and (min-width: 540px) {
    display: flex;
  }
`;
const StyledTableItem = styled(TableItem) `
  width: 50%;
  display: inline-block;
  margin-bottom: 6px;

  @media only screen and (min-width: 540px) {
    width: auto;
    display: inline-flex;
    margin-bottom: 0;
  }
`;
const InvoiceTable = ({ invoices }) => {
    const { t } = useTranslation(["dossier"]);
    return invoices.length > 0 ? (React.createElement(StyledInvoiceTable, null,
        React.createElement(StyledTableHeader, null,
            React.createElement(TableItem, { isHeading: true }, t("dossier:invoices.number")),
            React.createElement(TableItem, { isHeading: true }, t("dossier:invoices.date")),
            React.createElement(TableItem, { isHeading: true }, t("dossier:invoices.description")),
            React.createElement(TableItem, { isHeading: true }, t("dossier:invoices.amount"))),
        invoices.map(invoice => (React.createElement(StyledTableRow, { key: invoice.id },
            React.createElement(StyledTableItem, null,
                React.createElement(StyledLabel, null, t("dossier:invoices.number")),
                invoice.id),
            React.createElement(StyledTableItem, null,
                React.createElement(StyledLabel, null, t("dossier:invoices.date")),
                dateFormat(invoice.date)),
            React.createElement(StyledTableItem, null,
                React.createElement(StyledLabel, null, t("dossier:invoices.description")),
                invoice.description),
            React.createElement(StyledTableItem, null,
                React.createElement(StyledLabel, null, t("dossier:invoices.amount")),
                moneyFormat(invoice.amount))))))) : (React.createElement("p", null, t("dossier:invoices.empty")));
};
export default InvoiceTable;
